import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Snackbar,
  useMediaQuery,
} from '@mui/material';

import { forMobile } from '../../utils/media-queries';
import useAppError from './vm';

const AppError = () => {
  const isMobile = useMediaQuery(forMobile);

  const { error, handleClose } = useAppError();

  if (!error) return null;

  if (isMobile) {
    return (
      <Snackbar
        open={!!error}
        message={error}
        action={
          <Button color="inherit" size="small" onClick={handleClose}>
            Close
          </Button>
        }
      />
    );
  }

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={!!error}
      onClose={handleClose}
      aria-labelledby="app-error-title"
      aria-describedby="app-error-description"
    >
      <DialogContent sx={{ pb: 0 }}>
        <DialogContentText id="app-error-description">{error}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} autoFocus>
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppError;
